import {Route, Routes, Navigate} from 'react-router-dom';
import AiHelpDeskLayout from './AiHelpDeskLayout';
import {MyTickets} from './MyTickets';
import {EscalatedTickets} from './EscalatedTickets';
import {OngoingTickets} from './OngoingTickets';
import {ResolvedTickets} from './ResolvedTickets';
import {AbandonedTickets} from './AbandonedTickets';
import {AnonymousTickets} from './AnonymousTickets';
import SingleTicketView from './ticketView/SingleTicketView';

export const AiHelpDeskRoutes = () => {
  return (
    <Routes>
      <Route element={<AiHelpDeskLayout />}>
        <Route index element={<Navigate to="ongoing-tickets" replace />} />
        <Route path="my-tickets" element={<MyTickets />} />
        <Route
          path="awaiting-reply"
          element={
            <MyTickets
              emptyTitle="You're all caught up"
              emptyMessage="When a customer replies on one of your tickets, it shows up here, longest wait first."
            />
          }
        />
        <Route path="escalated-tickets" element={<EscalatedTickets />} />
        <Route path="ongoing-tickets" element={<OngoingTickets />} />
        <Route path="resolved-tickets" element={<ResolvedTickets />} />
        <Route path="abandoned-tickets" element={<AbandonedTickets />} />
        <Route path="anonymous-tickets" element={<AnonymousTickets />} />
      </Route>
      <Route path="ticket/:id" element={<SingleTicketView />} />
    </Routes>
  );
};
